/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_Select_EventsInputs */



/**
* | output |
* | --- |
* | "Selected {count} events in {group}" |
*
* @param {Assistant_Activity_Select_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_select_events = /** @type {((inputs: Assistant_Activity_Select_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Select_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements ${i?.count} sélectionnés dans ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ausgewählte ${i?.count}-Ereignisse in ${i?.group}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eventi ${i?.count} selezionati in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Избранные события ${i?.count} в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se seleccionaron los eventos ${i?.count} en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`在 ${i?.group} 中选择 ${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} で選択された ${i?.count} イベント`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में चयनित ${i?.count} घटनाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos selecionados ${i?.count} em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Selected ${i?.count} events in ${i?.group}`)
});